import React from 'react';
import { isStringField, Field } from '@truvity/widget__forms';
import { FormField } from '@truvity/widget__forms-mui-theme';

import { CredentialDid } from '../../../types';

import { CredentialSuggest } from './components/CredentialSuggest';
import { CredentialCard } from './components/CredentialCard';

export const LinkedCredential = ({ input, meta, typeDescriptor }: Field<CredentialDid | undefined>) => {
    if (!isStringField(typeDescriptor)) {
        throw new Error(`Incorrect descriptor type: ${input.name}`);
    }

    const { schemaIds } = typeDescriptor.ui;

    if (schemaIds == null) {
        throw new Error(`Unknown schema for linked credential fiels: ${input.name}`);
    }

    // HANDLERS
    const handleSelectSuggestion = (value: string) => {
        input.onChange(value);
    };

    const handleDeleteLinkedCredential = () => {
        input.onChange(undefined);
    };

    // RENDER
    const renderLinkedCredential = () => {
        if (input.value == null) {
            return (
                <CredentialSuggest
                    id={`${meta.form}-${input.name}`}
                    name={input.name}
                    schemaIds={schemaIds}
                    onSelect={handleSelectSuggestion}
                    isDisabled={meta.disabled}
                />
            );
        }

        return (
            <CredentialCard value={input.value} onDelete={handleDeleteLinkedCredential} isDisabled={meta.disabled} />
        );
    };

    return (
        <FormField meta={meta} typeDescriptor={typeDescriptor}>
            <div>{renderLinkedCredential()}</div>
        </FormField>
    );
};
